module.exports = __webpack_public_path__ + "img/GTM-integration-vidjet-step6.233bba6e.png";